import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './DeviceOverview.css';

const DeviceOverview = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-20% 0px -20% 0px' });

  return (
    <motion.section
      className="device-overview-section"
      ref={ref}
      initial={{ opacity: 0, y: 60 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, type: 'spring', bounce: 0.35 }}
      id="device-overview-section"
    >
      <div className="device-overview-header">
        <motion.h2
          style={{ color: '#091c6' }}
          initial={{ opacity: 0, x: -40 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ delay: 0.15, duration: 0.7, type: 'spring', bounce: 0.3 }}
        >
          Device Overview <span className="arrow-down">&#x2304;</span>
        </motion.h2>
      </div>
      <div className="device-overview-content">
        <motion.div
          className="device-overview-image-container"
          initial={{ opacity: 0, scale: 0.8, x: -60 }}
          animate={isInView ? { opacity: 1, scale: 1, x: 0 } : {}}
          transition={{ delay: 0.25, duration: 0.7, type: 'spring', bounce: 0.4 }}
        >
          <img 
            src="/images/GenixLocket.png" 
            alt="Genix Locket" 
            className="device-overview-image"
          />
        </motion.div>
        <motion.div
          className="device-overview-text-content"
          initial={{ opacity: 0, x: 60 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ delay: 0.35, duration: 0.7, type: 'spring', bounce: 0.4 }}
        >
          <h3>What is Genix Pendant ?</h3>
          <p>
            A compact, badge-sized, voice-first wearable that clinicians or health workers wear during
            consultations. It listens, understands, translates, and documents medical conversations—all powered
            by on-device AI + cloud sync.
          </p>
          <h4>Key Benefits -</h4>
          <ul className="key-benefits-list">
            <li><span className="check-icon">✓</span> Saves 60%+ of time spent on manual clinical documentation.</li>
            <li><span className="check-icon">✓</span> Reduces dependency on human translators/interpreters.</li>
            <li><span className="check-icon">✓</span> Improves compliance with audit trails and accurate documentation.</li>
            <li><span className="check-icon">✓</span> Expands care reach to populations who are underserved due to language or tech barriers.</li>
            <li><span className="check-icon">✓</span> Enhances empathy by allowing more face-to-face conversation and less screen time.</li>
          </ul>
          <a
  href="https://calendly.com/genixai-india/30min"
  target="_blank"
  rel="noopener noreferrer"
  className="schedule-call-button"
>
  Schedule a call ↗
</a>

        </motion.div>
      </div>
    </motion.section>
  );
};

export default DeviceOverview; 